<template>
  <div class="order-insurance">
    <div class="header">
      <div class="header-left">
        <div class="title">旅游保险</div>
        <div class="sub-title" v-if="order.order_insurance.insurance_type === 1 || order.order_insurance.insurance_type === 2">该保险由{{order.product_insurance.company_name}}提供</div>
      </div>
      <div class="header-right">
        <div class="process-btn" @click="goDetail('process')" v-if="order.order_insurance.insurance_type === 1 || order.order_insurance.insurance_type === 2">理赔流程</div>
      </div>
    </div>
    <div class="insurance-body" v-if="order.order_insurance.insurance_type === 1 || order.order_insurance.insurance_type === 2">
      <div class="insurance-info-item">
        <div class="item-label">保险名称</div>
        <div class="item-value insurance-name">
          <div class="name">{{order.product_insurance.insurance_name}}</div>
          <div class="link" @click="goDetail('detail')">查看详情</div>
        </div>
      </div>
      <div class="insurance-info-item">
        <div class="item-label">被保人</div>
        <div class="item-value">
          {{name}}
        </div>
      </div>
      <!-- 用户自选，所有人待投保，可以看到选择的保障天数、生效日期-->
      <div class="insurance-date-box" v-if="userInsuranceEveryNotInsure">
        <div class="date-item">
          <div class="item-label">保障天数</div>
          <div class="item-value">{{protectDayString}}</div>
        </div>
        <div class="date-item">
          <div class="item-label">生效日期</div>
          <div class="item-value">{{order.order_insurance.start_date | date('YYYY年MM月DD日')}}</div>
        </div>
      </div>
      <div class="insurance-date-box" v-else-if="showDateArr">
        <div class="date-item" v-for="item in dateArr" :key="item.key">
          <div class="item-label">{{item.key}}</div>
          <div class="item-value">{{item.value}}</div>
        </div>
      </div>
      <div class="insurance-order-box">
        <div class="appilcant-header">
          <div class="title">保险订单</div>
          <div class="header-right">
            <template v-if="userInsuranceSomeInsure">
              <div class="btn" @click="changeInsurance">修改保期</div>
              <div class="btn" @click="refundInsurance">我要退保</div>
            </template>
            <div v-if="showDownLoadAll" class="btn btn-blue" :class="{disabled: allDisabled}" @click="downLoadAll">批量下载保单</div>
          </div>
        </div>
        <div class="applicant-list-box">
          <div class="list-label">保险状态</div>
          <div class="list-body">
            <div class="applicant-item" v-for="item in collapsed ? applicantList : applicantList.slice(0, 3)" :key="item.order_applicant_id">
              <div class="applicant-name">{{item.applicant_name}}</div>
              <div class="applicant-policy" v-if="item.applicant_insurance && item.applicant_insurance.policy_num">{{item.applicant_insurance.policy_num}}</div>
              <img class="applicant-status" v-if="item.applicant_insurance" :src="statusImgMap[item.applicant_insurance.status]" />
              <div class="down-btn"
                :class="{'disabled': singleDisabled}"
                @click="downLoad(item.order_applicant_id)"
                v-if="item.applicant_insurance && [1, 2].indexOf(item.applicant_insurance.status) > -1"
              >下载保单</div>
            </div>
          </div>
        </div>
        <div class="expand-box" v-if="applicantList.length > 3">
          <div class="expand-body" @click="collapsed =! collapsed" >
            <div class="expand-text" v-if="collapsed">收起</div>
            <div class="expand-text" v-else>展开剩余 {{applicantList.length - 3}} 人</div>
            <img class="down-icon" :class="{expand: collapsed }" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="insurance-body" v-if="order.order_insurance.insurance_type === 3">
      <div class="insurance-info-item">
        <div class="item-label">保险名称</div>
        <div class="item-value insurance-name">
          <div class="name">境外旅行保险高级套餐</div>
        </div>
      </div>
      <div class="insurance-info-item">
        <div class="item-label">被保人员</div>
        <div class="item-value insurance-name">
          <div class="name">{{name}}</div>
        </div>
      </div>
      <div class="insurance-info-item m-b-0">
        <div class="item-label">保险状态</div>
        <div class="item-value insurance-name">
          <div class="name">已确认</div>
        </div>
      </div>
    </div>
    <!-- 修改保期 -->
    <change-insurance-dialog v-if="order.user_order_id" v-model="showChangeInsuranceDialog" :order="order" @on-success="refreshOrder"></change-insurance-dialog>
    <!-- 退保 -->
    <refund-insurance-dialog v-if="order.user_order_id" v-model="showRefundInsuranceDialog" :order="order" @on-success="refreshOrder"></refund-insurance-dialog>

  </div>
</template>

<script>
import expand from '../../../components/common/expand';
import Http from '../../../libs/http.js';
import changeInsuranceDialog from '../../../components/insurance/change-insurance-dialog';
import refundInsuranceDialog from '../../../components/insurance/refund-insurance-dialog';

export default {
  components: {
    expand,
    changeInsuranceDialog,
    refundInsuranceDialog,
  },
  data() {
    return {
      statusArr: {
        0: '未投保',
        1: '未生效',
        2: '已生效',
        3: '退保成功',
        4: '退款成功',
        5: '已取消',
        6: '保期修改中',
        7: '保期修改失败',
      },
      statusImgMap: {
        0: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-0.png',
        1: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-1.png',
        2: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-2.png',
        3: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-3.png',
        4: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-4.png',
        5: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-5.png',
        6: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-6.png',
        7: 'https://o.666visa.cn/static/ssqwxa/order-confirm/insurance-status-7.png',
      },
      collapsed: false,
      allDisabled: false,
      singleDisabled: false,
      showChangeInsuranceDialog: false, // 是否显示修改保期弹窗
      showRefundInsuranceDialog: false, // 是否显示退保弹窗
    };
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    peer: {
      type: Object,
    },
  },
  computed: {
    // 已经购买了保险的申请人列表
    applicantList() {
      if (!this.order.applicant) return [];
      if (this.order.order_insurance.insurance_type === 1) {
        return this.order.applicant.filter(item => item.applicant_insurance);
      }
      return this.order.applicant;
    },
    name() {

      const nameArr = this.applicantList.map(item => item.applicant_name);

      let name = '';

      if (nameArr.length < 4) {
        name = nameArr.join('、');
      } else {
        name = `${nameArr.slice(0, 3).join('、')}等${nameArr.length}位申请人`;
      }

      return name;
    },
    dateArr() {

      const order_insurance = this.order.order_insurance;

      let arrSort = this.order.applicant.filter((item) => {
        if (item.applicant_insurance && [1, 2].indexOf(item.applicant_insurance.status) > -1) {
          return item.applicant_insurance.insure_time;
        }
        return false;
      });

      arrSort = arrSort.map(item => item.applicant_insurance.insure_time);

      arrSort.sort((pre, aft) => new Date(pre).getTime() - new Date(aft).getTime());

      let end = order_insurance.end_date;

      end = new Date(new Date(end).getTime() - 24 * 60 * 60 * 1000);

      end = `${end.getUTCFullYear()}年${end.getUTCMonth() + 1}月${end.getUTCDate()}日`;

      let start = order_insurance.start_date;

      start = new Date(start);

      start = `${start.getUTCFullYear()}年${start.getUTCMonth() + 1}月${start.getUTCDate()}日`;

      let effect = new Date(arrSort[0].replace(/-/g, '/'));

      effect = `${effect.getUTCFullYear()}-${this.timeTr(effect.getUTCMonth() + 1)}-${this.timeTr(effect.getUTCDate())} ${this.timeTr(effect.getHours())}:${this.timeTr(effect.getMinutes())}:${this.timeTr(effect.getSeconds())}`;

      const arr = [
        {
          key: '生效日期',
          value: start,
        },
        {
          key: '终止日期',
          value: end,
        },
        {
          key: '投保时间',
          value: effect,
        },
      ];

      return arr;
    },
    showDownLoadAll() {
      return this.order.applicant.filter(item => item.applicant_insurance && [1, 2].indexOf(item.applicant_insurance.status) > -1).length > 1;
    },
    showDateArr() {
      return this.order.applicant.some(item => item.applicant_insurance && [1, 2].indexOf(item.applicant_insurance.status) > -1);
    },
    // 自选保险所有人未投保, 包括未投保 ，保期修改中，保期修改失败
    userInsuranceEveryNotInsure() {
      const isUserInsurance = this.order.order_insurance && this.order.order_insurance.insurance_type === 1;
      // 所有购买了保险人未投保
      const isAllNotInsured = this.order.applicant.every(item => !item.applicant_insurance || (item.applicant_insurance && [0, 6, 7].indexOf(item.applicant_insurance.status) > -1));
      return isUserInsurance && isAllNotInsured;
    },
    // 用户选择的保障天数范围
    protectDayString() {
      const fee_desc = this.order.product_insurance.fee_desc;
      const day = this.order.order_insurance.protect_days;
      let day_string = '';
      for (let i = 0; i < fee_desc.length; i++) {
        const item = fee_desc[i];
        if (+day >= item.min && +day <= item.max) {
          if (item.step === 0) {
            day_string = item.key;
            break;
          } else {
            day_string = `${day}天`;
          }
        } 
      }
      return day_string;
    },
    // 自选保险是否存在投保了的申请人（未生效和已生效）
    userInsuranceSomeInsure() {
      const isUserInsurance = this.order.order_insurance && this.order.order_insurance.insurance_type === 1;
      // 所有购买了保险人未投保
      const isSomeInsure = this.order.applicant.some(item => item.applicant_insurance && [1, 2].indexOf(item.applicant_insurance.status) > -1);
      return isUserInsurance && isSomeInsure;
    },
  },
  methods: {
    timeTr(item) {
      if ((`${item}`).length === 1) {
        return `0${item}`;
      }
      return item;

    },
    goDetail(type) {
      const routeUrl = this.$router.resolve({
        name: 'BusinessView',
        query: {
          caseCode: this.order.product_insurance.case_code,
          visa_product_id: this.order.visa_product_id,
          user_order_id: this.order.user_order_id,
          type,
        },
      });

      window.open(routeUrl.href, '_blank');
    },
    downLoad(id) {
      if (this.singleDisabled) {
        return;
      }
      this.singleDisabled = true;
      Http.post('/insurance_download_pdf', {
        order_applicant_id: id,
      }).then((res) => {
        window.open(res.file_url, '_blank');
        this.singleDisabled = false;
      }).catch((e) => {
        if (e) console.log(e);
        this.singleDisabled = false;
      });
    },
    downLoadAll() {
      this.allDisabled = true;
      Http.post('/insurance_download_batch', {
        user_order_id: this.order.user_order_id,
      }).then((res) => {
        window.open(res.file_url, '_blank');
        this.allDisabled = false;
      }).catch((e) => {
        if (e) console.log(e);
        this.allDisabled = false;
      });
    },
    changeInsurance() {
      const buyApplicant = this.order.applicant.filter(item => item.applicant_insurance);
      if (buyApplicant.some(item => item.applicant_insurance.status === 2)) {
        this.$message({
          message: '该保险已经生效，不支持修改保期，请您谅解',
          type: 'warning',
        });
      } else if (buyApplicant.some(item => [0, 6, 7].indexOf(item.applicant_insurance.status) > -1)) {
        // 存在“未投保”、“修改保期”、“修改保期失败”，不可进入
        this.$message({
          message: '暂不支持修改保期~',
          type: 'warning',
        });
      } else if (buyApplicant.some(item => item.applicant_insurance.status === 1)) {
        // 必须要存在未生效的投保人才能进入
        this.showChangeInsuranceDialog = true;
      } else {
        this.$message({
          message: '暂不支持修改保期~',
          type: 'warning',
        });
      }

    },
    refundInsurance() {
      const buyApplicant = this.order.applicant.filter(item => item.applicant_insurance);
      if (buyApplicant.some(item => item.applicant_insurance.status === 2)) {
        this.$message({
          message: '该保险已经生效，不支持退保，请您谅解',
          type: 'warning',
        });
      } else if (buyApplicant.some(item => item.applicant_insurance.status === 1)) {
        // 必须要存在未生效的投保人才能退保
        this.showRefundInsuranceDialog = true;
      } else {
        this.$message({
          message: '暂不支持退保~',
          type: 'warning',
        });
      }
    },
    // 修改保期成功
    refreshOrder() {
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="less" scoped>
.order-insurance{
  margin-top: 15px;
  background: #fff;
  line-height: 1;
  .header{
    height:44px;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    .header-left{
      display: flex;
      align-items: center;
      .title{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
        margin-right: 12px;
      }
      .sub-title{
        color: #91999F;
        font-size: 14px;
      }
    }
    .header-right{
      display: flex;
      align-items: center;
      .process-btn{
        cursor: pointer;
        border:1px solid rgba(89,159,255,1);
        border-radius:2px;
        height:36px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #599FFF;
      }
    }

  }
  .insurance-body{
    padding: 24px;
    .insurance-info-item{
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &.m-b-0{
        margin-bottom: 0;
      }
      .item-label{
        color: #91999F;
        font-size: 14px;
        flex-shrink: 0;
        width: 64px;
        margin-right: 4px;
      }
      .item-value{
        color: #2F333D;
        font-size: 14px;
        &.insurance-name{
          display: flex;
          align-items: center;
          .name{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .link{
            flex-shrink: 0;
            display: flex;
            align-items: center;
            margin-left: 12px;
            color: #599FFF;
            font-size: 14px;
            cursor: pointer;
            &::after{
              content: '';
              width: 12px;
              height: 12px;
              margin-left: 4px;
              background: url(https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png) no-repeat center / 100% 100%;
            }
          }
        }
      }
    }
    .insurance-date-box{
      display: flex;
      align-items: center;
      .date-item{
        display: flex;
        align-items: center;
        margin-right: 48px;
        position: relative;
        &::after{
          content: "";
          width: 1px;
          height: 12px;
          background: #DEE2E6;
          position: absolute;
          top: 50%;
          right: -24px;
          transform: translateY(-50%);
        }
        &:last-child{
          margin-right: 0;
          &::after{
            display: none;
          }
        }
        .item-label{
          color: #91999F;
          font-size: 14px;
          flex-shrink: 0;
          width: 64px;
          margin-right: 4px;
        }
        .item-value{
          color: #2F333D;
          font-size: 14px;
        }
      }
    }
    .insurance-order-box{
      margin-top: 20px;
      background: #FAFBFC;
      padding: 0 20px;
      .appilcant-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #E9EEF2;
        height: 57px;
        .title{
          color: #2F333D;
          font-size: 18px;
          font-weight: 600;
        }
        .header-right{
          display: flex;
          align-items: center;
          .btn{
            cursor: pointer;
            border:1px solid rgba(89,159,255,1);
            border-radius:2px;
            height:36px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #599FFF;
            min-width: 96px;
            margin-left: 10px;
            &.disabled{
              cursor: not-allowed;
            }
            &.btn-blue{
              background: #599FFF;
              color: #fff;
              &.disabled{
                cursor: not-allowed;
                background: rgba(89,159,255,0.7);
              }
            }
          }
        }
      }
      .applicant-list-box{
        padding: 16px 0;
        display: flex;
        align-items: flex-start;
        .list-label{
          flex-shrink: 0;
          color: #91999F;
          font-size: 14px;
          margin-right: 16px;
          line-height: 24px;
        }
        .list-body{
          flex-grow: 1;
          overflow: hidden;
          .applicant-item{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            height: 24px;
            &:last-child{
              margin-bottom: 0;
            }
            .applicant-name{
              color: #2F333D;
              font-size: 14px;
              margin-right: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .applicant-policy{
              flex-shrink: 0;
              color: #91999F;
              font-size: 14px;
              margin-right: 12px;
            }
            .applicant-status{
              height: 16px;
              flex-shrink: 0;
            }
            .down-btn{
              flex-shrink: 0;
              cursor: pointer;
              margin-left: 24px;
              border:1px solid rgba(89,159,255,1);
              border-radius:2px;
              height:24px;
              width: 68px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #599FFF;
              &.disabled{
                cursor: not-allowed;
              }
            }
          }
        }
      }
      .expand-box{
        border-top: 1px solid #E9EEF2;
        display: flex;
        justify-content: center;
        padding: 16px 0;
        .expand-body{
          display: flex;
          align-items: center;
          color: #599FFF;
          font-size: 14px;
          cursor: pointer;
          .down-icon{
            width: 14px;
            height: 14px;
            margin-left: 8px;
            transition: 0.15s all;
            &.expand{
              transform: rotate(180deg);
            }
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-insurance-detail.vue